import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static values = {
    key: String,
    active: { type: Boolean, default: false },
  }

  static targets = ['number']

  connect = () => {
    this.element.addEventListener('click', this.handleClick.bind(this))
  }

  handleClick = () => {
    if (!this.activeValue) {
      if (this.videos.length < 5) {
        this.activateElement()
      }
    }
    else {
      this.deactivateElement()
    }

    this.handleLimit()
  }

  activateElement = () => {
    this.activeValue = true
    this.numberTarget.style.backgroundColor = 'rgb(31 41 55)'
    this.numberTarget.style.border = '1px solid white'

    if (!this.videos.includes(this.keyValue)) {
      const videos = this.videos
      videos.push(this.keyValue)
      this.setVideos(videos)
      this.numberTarget.innerHTML = videos.length
    }
    this.updateAllNumbers()
  }

  deactivateElement = () => {
    this.activeValue = false
    this.numberTarget.style.backgroundColor = ''
    this.numberTarget.style.border = ''

    const index = this.videos.indexOf(this.keyValue)
    if (index > -1) {
      const videos = this.videos
      videos.splice(index, 1)
      this.setVideos(videos)
      this.numberTarget.innerHTML = ''
      this.updateAllNumbers()
    }
  }

  updateAllNumbers = () => {
    const videos = this.videos
    document.querySelectorAll('[data-controller="video-mockups"]').forEach((el) => {
      const numberEl = el.querySelector('[data-video-mockups-target="number"]')
      const key = el.dataset.videoMockupsKeyValue
      if (numberEl && videos.includes(key)) {
        const currentNumber = numberEl.innerHTML.trim()
        if (currentNumber !== '' && !isNaN(currentNumber)) {
          const newIndex = videos.indexOf(key) + 1
          numberEl.innerHTML = newIndex
        }
      }
    })
  }

  handleLimit = () => {
    const videos = this.videos
    document.querySelectorAll('[data-controller="video-mockups"]').forEach((el) => {
      const numberEl = el.querySelector('[data-video-mockups-target="number"]')
      if (videos.length >= 5 && (!numberEl || numberEl.innerHTML.trim() === '')) {
        el.classList.add('greyed-out')
        el.classList.remove('cursor-pointer')
      }
      else {
        el.classList.remove('greyed-out')
        el.classList.add('cursor-pointer')
      }
    })
  }

  get videos() {
    const hiddenField = document.querySelector('input[type="hidden"][name="image_keys"]')
    if (!hiddenField) return []
    try {
      return JSON.parse(hiddenField.value || '[]')
    }
    catch (e) {
      console.error('Error parsing JSON from hidden field:', e)
      return []
    }
  }

  setVideos(videos) {
    const hiddenFields = document.querySelectorAll('input[type="hidden"][name="image_keys"]')

    const jsonString = JSON.stringify(videos)

    hiddenFields.forEach((field) => {
      field.value = jsonString
    })
  }
}
